<template>
	<Tab
  title="收费系统设置"
  v-if="isRelation"
  :tabList="tabList"
  :path="path">
    <SmartForm
      style="margin-top: 30px"
      :slot="tabName"
      :formList="tabName==='manufacturer' ? manufacturerList : httpList"
      :formLabelWidth=120
      :columns="columns"
      :relationList="relationList"
      :values="tabName==='manufacturer' ? formValue.manufacturer : formValue.setHttp"
      :buttonList="manuButtonList">
    </SmartForm>
  </Tab>
</template>

<script>
import Tab from '@/components/Tab'
import SmartForm from '@/components/SmartForm'
import { fetchCreate, fetchRelation } from '@/utils/api'
import { expire } from '@/utils/auth'
// import { pinyinInitial } from 'hanyu-pinyin'

export default {
  name: 'Setting',
  components: {
    Tab,
    SmartForm
  },
  data () {
    const that = this
    const tabList = [{label: '厂商对接', name: 'manufacturer'}]
    return {
      isLoading: false,
      isRelation: false,
      tabList: tabList,
      tabName: this.$route.query.state || tabList[0].name,
      path: '/system/chargeSetting',
      resource: '/dock/interfaceConfig',
      httpList: ['url'],
      filterByAlways: [],
      relationList: [],
      formValue: {
        manufacturer: {
          dockTypeId: 'common',
          manufacturerId: 99999,
          packageVersion: '',
          packageName: '',
          packagePath: ''
        },
        setHttp: {
          dockTypeId: 'http',
          url: ''
        }
      },
      manuButtonList: [{
        name: 'submit',
        label: '保存',
        validate: true,
        funcProps: {
          el: this
        },
        func: (data, props) => {
          const formValue = this.formValue[this.tabName]
          fetchCreate({
            resource: that.resource,
            data: formValue
          }).then(data => {
            console.info('data:', data)
            if (data) {
              this.$msgbox('保存成功!')
            }
          })
        }
      }],
      columns: {
        customerId: {
          label: '客户'
        },
        manufacturerId: {
          label: '厂商',
          relation: 'manufacturerId',
          type: 'select',
          form: {
            type: 'select',
            width: 350,
            rules: [{
              type: 'required',
              message: '请选择厂商'
            }]
          }
        },
        dockTypeId: {
          label: '对接形式',
          type: 'select'
        },
        packageVersion: {
          label: '系统版本',
          relation: 'packageVersion',
          type: 'select',
          form: {
            type: 'select',
            width: 350,
            rules: [{
              type: 'required',
              message: '请选择系统版本'
            }]
          }
        },
        packageName: {
          label: '插件包',
          relation: 'packageName',
          type: 'select',
          form: {
            type: 'select',
            width: 350,
            rules: [{
              type: 'required',
              message: '请选择插件包'
            }]
          }
        },
        packagePath: {
          label: '插件包路径',
          form: {
            type: 'input',
            width: 350,
            rules: [{
              type: 'required',
              message: '请填写插件包路径'
            }]
          }
        },
        url: {
          label: 'http接口URL',
          type: 'input',
          form: {
            type: 'input',
            width: 350,
            rules: [{
              type: 'required',
              message: '请填写http接口URL'
            }]
          }
        },
        creatorId: {
          label: '创建者'
        },
        createTime: {
          label: '创建时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        },
        updateTime: {
          label: '更新时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss'
        }
      }
    }
  },
  created () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.getRelation()
  },
  watch: {
    $route (to, form) {
      this.tabName = to.query.state || this.tabList[0].name
      this.changeTabEvent(to.query.state)
    }
  },
  computed: {
    manufacturerList () {
      if (!this.formValue[this.tabName].manufacturerId) {
        return ['manufacturerId', 'packagePath']
      } else {
        return ['manufacturerId', 'packageVersion', 'packageName']
      }
    }
  },
  methods: {
    changeTabEvent (value = this.tabList[0].name) {
      this.tabName = value
    },
    getRelation () {
      this.isLoading = true
      const columnsKey = Object.keys(this.columns)
      let relationKeys = columnsKey.filter(key => { return this.columns[key].relation })
      fetchRelation({
        params: relationKeys.join(',')
      }).then(res => {
        console.log('relation:', res)
        this.relationList = res
        this.isRelation = true
        columnsKey.map(key => {
          const relation = this.columns[key].relation
          if (res[relation]) {
            const optionsInit = this.columns[key].optionsInit ? this.columns[key].optionsInit : []
            this.columns[key].options = [...optionsInit, ...res[relation]].map(option => {
              return {
                value: option.value !== undefined ? option.value : option.id,
                ...option
              }
            })
          }
        })
        this.$emit('getRelation', this.columns)
        // this.isLoading = false
        console.info('columns:', this.columns)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChargeSetting.vue?1a82b374